import { apiRequestDev } from './apiRequest';

export const getRidingShapes = async (config, pollId) => apiRequestDev(config, `/polls/shapes/${pollId}`);

export const getPollsShapesByRidingId = async (config, ridingId) =>
  apiRequestDev(config, `/polls/shapes/riding/${ridingId}`);

export const getRidingData = async (config, ridingId) => apiRequestDev(config, `/ridings/data/${ridingId}`);

export const getPollData = async (config, userId, pollId, category, subcategory, days, startDate, endDate) => {
  let url = `/polls/data/${pollId}?userId=${userId}`;

  if (category && subcategory && days) {
    url += `&category=${encodeURIComponent(category)}&subcategory=${encodeURIComponent(subcategory)}&days=${days}`;

    if (days === 'custom' && startDate && endDate) {
      url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
    }
  }

  return apiRequestDev(config, url);
};

export const getPollInfo = async (config, postalCode) => apiRequestDev(config, `/polls/postal/${postalCode}`);

export const getPollMessagesInfo = async (
  config,
  userId,
  ridingId,
  category,
  subcategory,
  days,
  startDate,
  endDate,
) => {
  let url = `/ridings/activity/${ridingId}?userId=${userId}&category=${encodeURIComponent(category)}&subcategory=${encodeURIComponent(subcategory)}&days=${days}`;

  if (days === 'custom' && startDate && endDate) {
    url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  }

  return apiRequestDev(config, url);
};

export const getPollMessagePoints = async (
  config,
  userId,
  ridingId,
  category,
  subcategory,
  days,
  startDate,
  endDate,
) => {
  let url = `/ridings/activity/points/${ridingId}?userId=${userId}&category=${encodeURIComponent(category)}&subcategory=${encodeURIComponent(subcategory)}&days=${days}`;

  if (days === 'custom' && startDate && endDate) {
    url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  }

  return apiRequestDev(config, url);
};
